import { toast, ToastContainer } from 'react-toastify';
import './App.css';
import Features from './components/Features';
import Header from './components/Header';
import Platforms from './components/Platforms';
import appImg from './dcs-iphonex.png';

function App() {
  const getMailClient = () => {
    window.location = 'mailto:hello@apfome.com?subject=Contact from DCS web';
    toast(
      "We've opened your email client. Not worked? Email us at hello@apfome.com"
    );
  };

  return (
    <div>
      <ToastContainer />

      <header>
        <Header />
      </header>
      <main>
        <div className='flex flex-col justify-center items-center m-20'>
          <Platforms />
          <img src={appImg} alt='' className='h-1/4 w-1/4' />
          <Features />
          <div className='flex flex-row space-x-5 justify-center'>
            <button className='bg-red-900 text-white py-2 px-5 hover:bg-white hover:text-red-900 hover:border-2 hover:border-red-900 hover:shadow-lg hover:scale-105 transition translate ease-in duration-500 rounded-lg mt-20'>
              Privacy Policy
            </button>
            <button
              onClick={() => {
                getMailClient();
              }}
              className='bg-white border-2 border-red-900 text-red-900 py-2 px-5 hover:bg-red-900 hover:text-white hover:shadow-lg hover:scale-105 transition translate ease-in duration-500 rounded-lg mt-20'
            >
              Contact Us
            </button>
          </div>
        </div>
      </main>
    </div>
  );
}

export default App;
